import axios from "axios";

const changeStatus = ({ id, status }) => {
  const body = {
    status: status,
    instant_lucky_draw_id: id,
  };

  return new Promise((resolve, reject) => {
    axios
      .post(`/campaignV2/customer/instantLuckyDraw/updateStatus`, body)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default changeStatus;
